<template>
  <section class="swpoll-footer">
    <div class="swpoll-powered">
      <p>Powered by</p>
      <a href="https://digitaljoy.media" target="_blank">
        <img alt="Digital Joy" src="./../assets/digitaljoy-dark-theme.svg" />
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PoweredBy',
  props: {
  }
}
</script>

<style scoped lang="scss">
.swpoll-footer {
  flex: 0 0 auto;
  margin: 16px auto;
  font-family: Arial, Helvetica, sans-serif;
}
.swpoll-powered {
  padding: 8px 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  opacity: 0.8;

  p {
    font-weight: 400;
    margin: 0;
    line-height: 1.3em;
    font-size: 10px;

    & + a img {
      width: 75px;
      margin-left: 8px;
    }
  }

  a {
    display: inline-block;
    line-height: 0.5em;
  }

  img {
    width: 34px;
    height: auto;
    display: inline-block;
  }
}

.isHorizontal {
  .swpoll-footer {
    padding-top: 0;
    margin: 0 auto;
  }
}

.style-bbl,
.style-veev {

  section {
    display: none;
  }
}

.style-wes {

  section {
    display: none;
  }
}

</style>
